module.exports = __webpack_public_path__ + "6b3b6c7d4bb9493628975c435f9159e2.png";